import React, { useEffect } from 'react';
import { Drawer, Form, Button, SelectPicker, Message } from 'rsuite';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';


interface DrawerViewProps {
  open: boolean;
  onClose: () => void;
  onFiltersChange: (filters: any) => void;
  onResetFilters: () => void;
  currentFilters: {
    timeslot: string;
    mode: string;
  };
  users: any[];
  usersLoading: boolean;
  toaster: any;
}

const GlobalWorkModesDrawerView: React.FC<DrawerViewProps> = ({
  open,
  onClose,
  onFiltersChange,
  onResetFilters,
  currentFilters,
  toaster
}) => {
  const [formValue, setFormValue] = React.useState(currentFilters);

  const timeslotOptions = [
    { label: 'AM', value: 'AM' },
    { label: 'PM', value: 'PM' }
  ];

  const modeOptions = [
    { label: 'Home Office', value: 'WFH' },
    // { label: 'Remote Working', value: 'REMOTE_WORKING' },
    { label: 'On Site With CheckIn', value: 'OnSiteWithCheckin' },
    { label: 'On Site Without CheckIn', value: 'OnSiteWithoutCheckin' },
    { label: 'Third Party Site', value: 'ThirdPartySite' },
    { label: 'Leave', value: 'Leave' },
    { label: 'Untraced', value: 'Untraced' }
  ];

  const handleSubmit = () => {
    const hasFilters = Object.values(formValue).some(value => value !== '' && value !== null);

    if (hasFilters) {
      onFiltersChange({
        timeslot: formValue.timeslot,
        mode: formValue.mode
      });
      toaster.push(
        <Message type="success" closable>
          {t('Filters applied successfully')}
        </Message>
      );
    } else {
      onResetFilters();
    }

    onClose();
  };

  const handleReset = () => {
    setFormValue({
      timeslot: '',
      mode: ''
    });
    onResetFilters();
    toaster.push(
      <Message type="info" closable>
        {t('Filters have been reset')}
      </Message>
    );
    onClose();
  };

  React.useEffect(() => {
    if (open) {
      setFormValue(currentFilters);
    }
  }, [open, currentFilters]);
  const { t } = useTranslation();

  return (
    <Drawer backdrop="static" size="sm" placement="right" onClose={onClose} open={open}>
      <Drawer.Header>
        <Drawer.Title>{t('Filter Options')}</Drawer.Title>
        <Drawer.Actions>
          <Button onClick={handleReset} appearance="subtle">
            {t('Reset')}
          </Button>
          <Button onClick={handleSubmit} appearance="primary">
            {t('Apply')}
          </Button>
          <Button onClick={onClose} appearance="subtle">
            {t('Cancel')}
          </Button>
        </Drawer.Actions>
      </Drawer.Header>

      <Drawer.Body>
        <Form fluid formValue={formValue} onChange={setFormValue}>
          <Form.Group>
            <Form.ControlLabel>{t('Timeslot')}</Form.ControlLabel>
            <Form.Control
              name="timeslot"
              accepter={SelectPicker}
              data={timeslotOptions}
              searchable
              placeholder={t("Select Timeslot")}
              block
            />
          </Form.Group>

          <Form.Group>
            <Form.ControlLabel>Mode</Form.ControlLabel>
            <Form.Control
              name="mode"
              accepter={SelectPicker}
              data={modeOptions}
              searchable
              placeholder={t("Select Mode")}
              block
            />
          </Form.Group>
        </Form>
      </Drawer.Body>
    </Drawer>
  );
};

export default GlobalWorkModesDrawerView;